export default __webpack_public_path__ + "b1023c72c5afaee8e04a5cd4dd6439a7.pdf";